<template>
  <BaseModal :is-open="isOpen" size="md">
    <template #header>
      <NavBar>
        <template v-if="!isServerError" #center><span>aviso</span></template>
        <template #right>
          <RoundedIcon
            data-testid="close-provider-error"
            icon-name="ic_cancel"
            main-color="transparent"
            :hover-color="NebraskaColors.backgroundHover"
            :text-color="NebraskaColors.elementPrimary"
            :hover-text-color="NebraskaColors.elementPrimary"
            :has-hover="true"
            @click="close"
          />
        </template>
      </NavBar>
    </template>

    <template #content>
      <div v-if="!isServerError" class="modal-content">
        <p
          data-testid="error-message"
          class="text-p-3 error-message"
          v-html="errorMessage"
        />
      </div>
      <div v-else class="modal-content">
        <ActionableHelperView :on-retry="onRetry" />
      </div>
    </template>

    <template v-if="!isServerError" #footer>
      <ModalFooterWallet
        left-button-label="Ok"
        :hide-right-button="true"
        @left-button-clicked="close"
      />
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ModalFooterWallet } from '@/modules/wallet-builder/src/components/Modals/ModalFooter';

import {
  NavBar,
  ActionableHelperView,
  BaseModal,
  RoundedIcon
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  components: {
    BaseModal,
    ModalFooterWallet,
    NavBar,
    ActionableHelperView,
    RoundedIcon
  }
})
export default class ProviderError extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  public isOpen!: boolean;

  @Prop({ type: String, required: false, default: 'Tente novamente.' })
  public errorMessage!: string;

  @Prop({ type: Boolean, required: false, default: false })
  public isServerError!: boolean;

  @Prop({ required: false, type: Function, default: () => {} })
  private onRetryFunction!: Function;

  public NebraskaColors = NebraskaColors;

  private close() {
    this.$emit('button-clicked');
  }

  private onRetry() {
    this.onRetryFunction();
    this.close();
  }
}
</script>

<style lang="less" scoped>
.modal-content {
  padding: @size-spacing-x600 calc(@size-spacing-x600 + @size-spacing-x300);
}

.error-message {
  text-align: center !important;
}
</style>
